import { Nil } from '@lib/common.lib'
import { isEmpty, isNil } from 'ramda'
import { ReadonlyNonEmptyArray } from 'types-ramda/es/tools'

export function expectNonNil<T>(x: T | Nil, message?: string): T | never {
    if (isNil(x)) {
        throw new Error(message ?? 'Encountered NIL value where NON-NIL is expected.')
    }

    return x
}

export function expectNonEmpty<T>(xs: readonly T[], message?: string): ReadonlyNonEmptyArray<T> | never {
    if (! Array.isArray(xs) || isEmpty(xs)) {
        throw new Error(message ?? 'Encountered empty list where non-empty is expected.')
    }

    return xs as unknown as ReadonlyNonEmptyArray<T>
}
